import {
  Autocomplete,
  TextField,
  styled,
  Box,
} from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { useSnackbar } from 'notistack';
import { useSearchParams } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { statusOptions } from '../../../../data/data';
import { SectionTitle } from '../../../../common/right-column/section-title';
import { useUpdateProjectStatus } from '../../../../hooks/mutation/update-project-status-mutation.hook';
import { useGetLogsByProject } from '../../../../hooks/query/get-logs-by-project-query.hook';

interface IFormInput {
  status: any
}

function Status({ queryInfo }: any) {
  const [searchParams] = useSearchParams();
  const {
    control, handleSubmit, reset,
  } = useForm<IFormInput>({
    mode: 'onBlur',
    // @ts-ignore
    defaultValues: useMemo(() => {
      return {
        status: statusOptions?.find((f) => f.value === queryInfo?.data?.getProjectById?.status),
      };
    }, [queryInfo]),
  });

  useEffect(() => {
    reset({
    // @ts-ignore
      status: statusOptions?.find((f) => f.value === queryInfo?.data?.getProjectById?.status),
    });
  }, [queryInfo.isSuccess]);

  const queryLogs = useGetLogsByProject(searchParams.get('projectId'));

  const { enqueueSnackbar } = useSnackbar();

  const mutate = useUpdateProjectStatus({
    onSuccess: (resp: any) => {
      queryInfo.refetch();
      queryLogs.refetch();
    },
    onError: (err: any) => {
      enqueueSnackbar(err.message);
    },
  });

  const onSubmit = (form: any): any => {
    const formValid: any = {
      status: form?.status?.value,
      projectId: searchParams.get('projectId'),
    };
    if (form?.status?.value !== queryInfo?.data?.getProjectById?.status) {
      mutate({ ...formValid });
    }
  };

  return (
    <Box
      component="form"
      onBlur={handleSubmit(onSubmit)}
    >
      <SectionTitle title="statut" />
      <Controller
        name="status"
        control={control}
        render={({ field }) => (
          <Autocomplete
            {...field}
            blurOnSelect="mouse"
            disablePortal
            disableClearable
            options={statusOptions}
            value={field.value || ''}
            onChange={(e, value) => {
              field.onChange(value);
            }}
            renderInput={
                (params) => (
                  <CssAutocomplete
                    {...params}
                    size="small"
                    placeholder="Statut"
                    fullWidth
                    variant="outlined"
                    color="primary"
                  />
                )
              }
          />
        )}
      />
    </Box>
  );
}

const CssAutocomplete = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.main,
  borderRadius: '4px',
  input: {
    fontWeight: 'bold',
    color: theme.palette.mode === 'dark' ? 'white' : 'white',
  },
  button: {
    color: theme.palette.mode === 'dark' ? 'inherit' : 'white !important',
  },
}));

export {
  Status,
};
